export class SetError {
    public static readonly type = '[Error] set';
    constructor(public error: any[] | any) {}
}

export class SetIsOwnError {
    public static readonly type = '[Is Own Error] set';
}

export class ResetErrors {
    public static readonly type = '[Errors] reset';
}
